import type { ComputedRef } from 'vue'
import { computed } from 'vue'

import { useTemporaryConversations } from '@/features/chat/composables/use-temporary-conversations.composable'
import useConversations from '@/features/chat/hooks/use-conversations.hook'

const useConversation = (conversationIdRef: ComputedRef<string | null>) => {
  const { conversationsRef, isPendingRef } = useConversations()
  const { getTemporaryConversation, isTemporaryConversation } = useTemporaryConversations()

  const conversationRef = computed(() => {
    if (!conversationIdRef.value) return undefined
    if (isTemporaryConversation(conversationIdRef.value)) {
      return getTemporaryConversation(conversationIdRef.value)
    }

    return conversationsRef.value.find((c) => c.conversationId === conversationIdRef.value)
  })

  const isConversationPendingRef = computed(() => {
    if (!conversationIdRef.value) return false
    if (isTemporaryConversation(conversationIdRef.value)) return false
    if (isPendingRef.value) return true
    return !conversationRef.value
  })

  return {
    conversationRef,
    isPendingRef: isConversationPendingRef,
  }
}

export default useConversation
